import { render } from "./RoutesList.vue?vue&type=template&id=70188994"
import script from "./RoutesList.vue?vue&type=script&lang=js"
export * from "./RoutesList.vue?vue&type=script&lang=js"

import "./RoutesList.vue?vue&type=style&index=0&id=70188994&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__